import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { DepartementService } from "../../core/service/departement.service";
import { DirectionService } from "../../core/service/direction.service";
import { Departement } from "../../core/model/departement";
import { Direction } from "../../core/model/direction";

@Component({
  selector: "app-edit-departement",
  templateUrl: "./edit-departement.component.html",
  styleUrls: ["./edit-departement.component.scss"],
})
export class EditDepartementComponent implements OnInit {
  @Input()
  set departement(value: Departement) {
    if (value) {
      this._departement = {
        ...value,
        direction: value.direction ? { ...value.direction } : new Direction(),
      };
      this.cdr.detectChanges();
    }
  }
  get departement(): Departement {
    return this._departement;
  }

  private _departement: Departement;
  directions: Direction[];

  form2: FormGroup;
  pressButton: Boolean = false;
  loading = true;

  constructor(
    private _departementService: DepartementService,
    private _directionervice: DirectionService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      code: [null, Validators.compose([Validators.required])],
      label: [null, Validators.compose([Validators.required])],
      direction: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getDirections();
  }

  getDirections() {
    this.loading = true;
    this._directionervice.getAllDirections().subscribe(
      (data) => {
        this.directions = data;
        this.loading = false;
        this.cdr.detectChanges();
      },
      (error) => {
        console.log(error);
        this.loading = false;
        this.cdr.detectChanges();
      }
    );
  }

  save(): void {
    this.pressButton = true;

    const selected = (this.directions || []).find(
      (d) => d.id == this.departement.direction.id
    );
    if (selected) {
      this.departement.direction = { ...selected };
    }

    this._departementService
      .putDepartement(this.departement)
      .pipe(first())
      .subscribe(
        () => {
          this.pressButton = false;
          this.activeModal.close(this.departement);
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
